import React from 'react';
import { Button } from 'semantic-ui-react';

// eslint-disable-next-line import/prefer-default-export
export const renderTableColumns = (t, handleRetryPayment) => [
  {
    title: t('paymentScheduleTable.paymentDate'),
    property: 'beforeDate',
    sortable: false,
  },
  {
    title: t('paymentScheduleTable.paymentAmount'),
    property: 'amount',
    sortable: false,
  },
  {
    title: '',
    sortable: false,
    customCell: (row) => (
      <Button
        disabled={row.isDisabled}
        onClick={() => {
          handleRetryPayment(row.id);
        }}
      >
        {t('rebootPayment')}
      </Button>
    ),
  },
];
